import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable, WithChildren } from 'utils-next/types'

import { Theme, Typography } from '@mui/material'

export type SearchEngineSectionProps = ExtendableStyles &
  Testable &
  WithChildren & {
    title: string
  }

export function SearchEngineSection({ className, children, title, ...otherProps }: SearchEngineSectionProps) {
  const { classes } = useStyles()
  return (
    <div className={classNames(className, classes.formSection)} {...otherProps}>
      <Typography variant="h6">{title}</Typography>
      <div className={classes.formContent}>{children}</div>
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  formSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  formContent: {
    marginTop: spacing(2),
  },
}))
